import React from 'react'
import Skeleton from 'src/common/ui-kit/Skeleton/Skeleton'

interface MarketDepthChartSkeletonProps {
  width?: string | number
  height?: string | number
  className?: string
  customStyles?: React.CSSProperties
}

const MarketDepthChartSkeleton: React.FC<MarketDepthChartSkeletonProps> = ({
  width = '100%',
  height = 200,
  className,
  customStyles,
}) => {
  return (
    <div className='chart-skeleton-container' style={{ width, height }}>
      {/* The skeleton fills the container */}
      <Skeleton
        width='100%'
        height='100%'
        variant='rect'
        className={className}
        customStyles={customStyles}
      />
    </div>
  )
}

export default MarketDepthChartSkeleton
